// @flow

function isNullOrUndefined(value : any) : boolean {
    return value === null || value === undefined
}

export default isNullOrUndefined;